module.exports = __webpack_public_path__ + "img/tech-and-it-icon.e39560e0.svg";